import { gql } from '@apollo/client';

export const GET_ACTIVITY_TARGETS = gql`
  query GetActivityTargets($activityId: ID!) {
    activityTargets: getActivityTargets(activityId: $activityId) {
      id
      cohort {
        id
        name
      }
      institution {
        id
        name
      }
    }
  }
`;
